import {dateEnTexte} from 'ff-common';
import type {CatalogueMarketplace, Commande} from 'api-types/ffconnect';
import type {TFunction} from 'i18next';

export function getCommandeMarketplaceId(
  commande: Pick<Commande, '_embedded'>,
): CatalogueMarketplace | undefined {
  return commande._embedded?.lignes_de_commande?.find(
    (ligne) => ligne.marketplace_id && ligne.marketplace_id !== 'FF',
  )?.marketplace_id;
}

export function getCommandeDateLabel(
  commande: Pick<Commande, 'tolede' | '_embedded'>,
  t: TFunction,
): string {
  const marketplaceId = getCommandeMarketplaceId(commande);

  if (marketplaceId) {
    const marketplace = t(`marketplace.${marketplaceId}`);
    return `${t('commande.commande_marketplace_du', {marketplace})} ${dateEnTexte(commande.tolede.cree_le)}`;
  }

  if (commande.tolede.mode_de_rendu === 'presta_direct') {
    return `${t('commande.commande_du')} ${dateEnTexte(commande.tolede.cree_le)}`;
  }

  return `${t('commande.livraison_du')} ${dateEnTexte(commande.tolede.date_de_livraison_ou_d_enlevement)}`;
}
